module.exports = __webpack_public_path__ + "img/teatro@x1.5aa65f8e.png";